/**
 * What creating a free agent account unlocks (founder decision F6,
 * 2026-10-21): open agent sign-up, no waitlist. A signed-out visitor browses
 * the public brokerage pages; each of these is behind a prompt that says what
 * it unlocks. This table is the only place that copy lives.
 *
 * "compensation" covers the compensation model, fee structure and leads — the
 * shape, never numbers (CLAUDE.md, Key product rules: Compensation).
 */
export type SignUpUnlock = "compare" | "compensation" | "message" | "feed";

export const SIGN_UP_PROMPTS: Record<SignUpUnlock, string> = {
  compare: "Create a free account to compare brokerages",
  compensation: "Create a free account to see compensation, fees and leads",
  message: "Create a free account to message this brokerage",
  feed: "Create a free account to see the feed",
};

export function isSignUpUnlock(value: unknown): value is SignUpUnlock {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(SIGN_UP_PROMPTS, value);
}

/** The row heading where the prompt stands in for hidden compensation, fee and lead details. */
export const GATED_INSIGHTS_LABEL = "Compensation, fees and leads";

/** The button label that opens sign-up. */
export const SIGN_UP_ACTION = "Create free account";
